import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
  DuiContext, //! 數位集章功能
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import MenuItemWithDialog from "jsdc-dui/dist/components/LeftMenuBar/MenuList/MenuItemWithDialog";
import Checkin from "jsdc-dui/dist/components/Icons/Checkin";
import headerImg from "./assets/key-art.svg";
import headerImgMb from "./assets/key-art_mobile.jpg";
import aboutImg from "./assets/about.jpg";

const EVENT_ID = "n0017";

//TODO: aboutWalkContent
const aboutWalkContent = `「雙溪」，乍聽到這個地名，幾乎所有人都會想到，那就是在故宮旁邊啊！對不起，那是外雙溪。
在這裡【頂雙溪】是它的原名。
有關雙溪開墾的歷史，最早見於史料者，可以溯至乾隆46年(西元1781年)(註一)。
頂雙溪地區有先民移入開墾(連元橋、吳爾)，始於嘉慶17年(西元1812年)(註二)。
同治7年(西元1868年)，雙溪三忠廟新廟落成，威惠廟立，至同治13年(西元1874年)，沈葆楨設立郵務站(註三)，即將【頂雙溪】的地理定位與聚落，完整的確立。

頂雙溪之所以興盛，除了水源充足，土地肥沃，足以開墾外，它的交通地位重要，是早期淡蘭古道北路(官路)的重要中繼站(註四)，在鐵路開通前，此地是往來噶瑪蘭最重要的門戶，鐵路開通後(西元1923年)，人貨運輸便捷更帶動了民國60年代煤礦業的興起，讓人口移入聚落擴張。但隨著礦業的沒落，產業的外移，雙溪，逐漸地淡出了大家的視界。礦業污染的消失再加上雙溪列入水源保護區，讓這裡重回純淨的山林田野，留下不受商業化渲染的古樸小鎮，對比城市現代快速，這裡已成為大台北美麗的後花園，更是品味古道文旅的朝聖之地。

新北市立雙溪高級中學，自民國35年(西元1946年)創立至今，服務在地學子已近80個年頭，從成立初級中學到增設高中部，更進一步的開辦綜合高中業務，均以考量在地就學學子的需求，開設多元的課程，提升學生能力為主要目標。自民國103年起，由社會領域教師共同研發地方學課程『漫遊雙溪』，由校內至校外，由近而遠，從《蔴竹坑土地公廟》《連舉人厝》《頂雙溪渡船頭》《三忠廟》《林益和堂》…等，帶領學生認識這已發展了二百年的在地小鎮，課程導入社會學研究方法與實作，培育孩子們對社區的關懷心與行動力。

註一：雙溪鄉志卷之一，大事紀，頁7
註二：雙溪鄉志卷之一，大事紀，頁12-13
註三：雙溪鄉志卷之一，大事紀，頁22、24
註四：淡蘭古道北路，第一章，頁26、70
`;

const credit = `
<div>
  團隊介紹：新北市政府教育局新課綱行動協作平臺，聯絡電話(02)29559019
  <br><br>
  <ul>
    <li style="list-style-type: cjk-ideographic;">
      本圖臺是由新北市政府教育局及智紳數位文化有限公司共同協力建置：
      <br>
      <br>1. 圖臺內容：新北市政府教育局
      <br>
      <br>2. 圖臺系統開發：智紳數位文化事業有限公司
    </li><br>
    <li style="list-style-type: cjk-ideographic;">
      除另有聲明外，本網站內容採用創用 CC 姓名標示-非商業性-相同方式分享4.0授權條款授權公眾使用，您可以依授權條款複製、引用、轉載，唯請於合理位置標示本站網址：新北市政府教育局
      <a href="https://www.ntpc.edu.tw/" target="_blank">https://www.ntpc.edu.tw/</a>
    </li>
  </ul>
</div>
`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [{ county: "新北市", town: "雙溪區" }], //TODO: weather 氣象預測地點
  },
  themeConfig: {
    "--dui-primary": "#648e9a", //TODO: theme
    "--dui-accent": "#0d92aa", //TODO: 數位集章按鈕
    "--dui-secondary": "#648e9a", //TODO: theme
    "--dui-bg-secondary": "#ffc361", // Dialog background
    "--dui-bg-accent": "#b7c6c8", //TODO: background
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};
// #e4e7cb
// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);
  const dui = useContext(DuiContext); //! 數位集章功能

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);

  return (
    <div className="root">
      <DguideWalksApp
        language="zh-TW"
        //! 左側數位集章選項
        mainMenuChildren={
          <MenuItemWithDialog
            Icon={Checkin}
            title="數位集章"
            active={dui.activeMenuId === "數位集章"}
            {...dui.menuSwitcherAction("數位集章")}
          >
            {dui.activeMenuId === "數位集章" && (
              <iframe
                title="數位集章"
                style={{ height: "100%", border: 0, borderRadius: "5px" }}
                src={`https://map.jsdc.com.tw/tools/checkin/${EVENT_ID}/showlist.php?a=${EVENT_ID}`}
              ></iframe>
            )}
          </MenuItemWithDialog>
        }
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        //TODO: map view bound
        latLng(25.0388311867168, 121.86716344867261),
        latLng(25.034258999438983, 121.86107017970653),
      ),
      maxZoom: 20,
    }),
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider
        Jsdc={Jsdc}
        config={config}
      >
        <DuiContextProvider {...duiConfigProps}>
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
